import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { Box } from 'shared/mui/Box';
import { ListItemText } from 'shared/mui/List';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';

const defaultColumns = { width: 0 };

export const DatagridStyled = styled(DatagridConfigurableWithStickyActions)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderBottomRightRadius: '4px',
  borderBottomLeftRadius: '4px',
  borderTop: 'none',
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  '& .MuiTableCell-root': {
    verticalAlign: 'middle!important',
  },
  '& .RaDatagrid-headerCell': {
    padding: '10px 16px',
  },
  '& .MuiTableCell-body': {
    verticalAlign: 'top',
    padding: '16px',
  },
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.tableHead,
  },
  '& .column-index': defaultColumns,
  '& .column-periodFrom': defaultColumns,
  '& .column-currencyCode': defaultColumns,
  '& .column-paymentAmount, .column-payoutAmount, .column-refundAmount, .column-chargeback, .column-commissionPaymentValue, .column-commissionPayoutValue, .column-commissionRefundValue, .column-commissionChargebackValue, .column-cumulativeTotalAmount, .column-totalAmount':
    {
      ...defaultColumns,
      textAlign: 'right',
    },
}));

export const StyledCumulativeReportPeriod = styled('div')<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    width: '100%',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.divider}`,
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
    borderBottomRightRadius: isOpen ? 0 : '4px',
    borderBottomLeftRadius: isOpen ? 0 : '4px',
    padding: '0 16px',
    backgroundColor: theme.palette.background.default,
  }),
);

export const ListItemTextStyled = styled(ListItemText)({
  '.MuiListItemText-primary': {
    fontSize: '14px',
  },
  textDecoration: 'none',
});

export const LinkStyled = styled(Link)({
  textDecoration: 'none',
});

export const BoxStyled = styled(Box)({
  marginBottom: '16px',
});
